import React from 'react'
import {Form, Icon, Input, Select, Radio} from 'antd';
import SubstudyText from './Texts/SubstudyText';
import Signature from "./Signature";
import SignatureTrimmed from "./SignatureTrimmed";

const { Option } = Select;

export default class extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const props = this.props;
    const showForEmail = !(props.consentMethodType === 'SubstudyEmail' && !props.token);
    const isEmail = props.consentMethodType === 'SubstudyEmail'
    const isPatient = props.consentPersonType === 'Patient';
    const isSurrogate = props.consentPersonType === 'Surrogate';

    return (
      <div className="form-group">
        <h4>Consent Process - Substudy</h4>

        <div className="form-group-details">
          <h5>Site ID: <b>{props.siteID}</b></h5>
          <h5>User ID: <b>{props.userID}</b></h5>
          <h5>Subject ID: <b>{props.subjectID}</b></h5>
        </div>

        <SubstudyText {...props} />

        <p><strong>Server Date (UTC): {props.date || props.consentDate}</strong></p>
        <p><strong>Consent Type: {props.consentPersonType}</strong></p>
        <p><strong>Consent Method: {props.consentMethodType}</strong></p>
        <p>&nbsp;</p>


        {isEmail && <Form.Item>
          <label>
            <div className='form-label'>Participant Email</div>
            {props.form.getFieldDecorator('wp_participant_email', {
              initialValue: props.wp_participant_email,
              rules: [{required: true, message: 'Please enter the participant\'s email'}, {type: 'email'}],
            })(
              <Input disabled={props.token} placeholder="Participant Email"/>
            )}
            </label>
          </Form.Item>}


        {showForEmail && <Form.Item>
          <label>
            <div className='form-label'>I agree to being contacted in relation to this study</div>
            {props.form.getFieldDecorator('wp_participant_agree_being_contacted', {
              rules: [{
                required: true,
                message: 'Required'
              }],
            })(
              <Radio.Group>
                <Radio value='true'>
                  Yes
                </Radio>
                <br/>
                <Radio value='false'>
                  No
                </Radio>
              </Radio.Group>
            )}
          </label>
        </Form.Item>}

        {isPatient && <Form.Item>
          <label>
            <div className='form-label'>Participant printed name</div>
            {props.form.getFieldDecorator('wp_consent_participant_name', {
              initialValue: props.wp_consent_participant_name,
              rules: [{
                required: true,
                message: 'Participant printed name is required'
              }],
            })(
              <Input
                prefix={<Icon type="user" style={{color: '#eee'}}/>}
                placeholder="Participant printed name"
              />
            )}
          </label>
        </Form.Item>}

        {isPatient && showForEmail && <Signature fieldName='wp_consent_participant_signature' label='Participant signature' form={props.form} /> }

        {isSurrogate && <Form.Item>
          <label>
            <div className='form-label'>Legal guardian’s printed name</div>
            {props.form.getFieldDecorator('wp_consent_guardian_name', {
              initialValue: props.wp_consent_guardian_name,
              rules: [{
                required: true,
                message: 'Legal guardian’s printed name is required'
              }],
            })(
              <Input
                prefix={<Icon type="user" style={{color: '#eee'}}/>}
                placeholder="Legal guardian’s printed name"
              />
            )}
          </label>
        </Form.Item>}

        {isSurrogate && !isEmail && <Signature fieldName='wp_consent_guardian_signature' label="Legal guardian's signature" form={props.form} />}

        {!isEmail && <Form.Item>
          <label>
            <div className='form-label'>Witness printed name</div>
            {props.form.getFieldDecorator('wp_consent_witness_name', {
              initialValue: props.wp_consent_witness_name,
              rules: [{
                required: true,
                message: 'Witness printed name is required'
              }],
            })(
              <Input
                prefix={<Icon type="user" style={{color: '#eee'}}/>}
                placeholder="Witness printed name"
              />
            )}
          </label>
        </Form.Item>}

        {!isEmail && <Signature fieldName='wp_consent_witness_signature' label="Witness signature" form={props.form} /> }

        <p style={{textAlign: 'left'}}><b>I, the undersigned, have fully explained the relevant details of this research study to the participant named above and believe that the participant has understood and has knowingly given their consent.</b></p>

        <Form.Item>
          <label>
            <div className='form-label'>Printed Name</div>
            {props.form.getFieldDecorator('wp_consent_investigator_name', {
              initialValue: props.wp_consent_investigator_name,
              rules: [{
                required: true,
                message: 'Printed name is required'
              }],
            })(
              <Input
                disabled={props.token}
                prefix={<Icon type="user" style={{color: '#eee'}}/>}
                placeholder="Printed Name"
              />
            )}
          </label>
        </Form.Item>

        <Form.Item>
          <label>
            <div className='form-label'>Role in the study</div>
            {props.form.getFieldDecorator('wp_consent_investigator_role', {
              initialValue: props.wp_consent_investigator_role,
              rules: [{
                required: true,
                message: 'Role in the study is required'
              }],
            })(
              <Input
                disabled={props.token}
                prefix={<Icon type="user" style={{color: '#eee'}}/>}
                placeholder="Role in the study"
              />
            )}
          </label>
        </Form.Item>

        {!props.token && <Signature fieldName='wp_consent_investigator_signature' label="Signature" form={props.form} /> }

        {showForEmail && <SignatureTrimmed fieldName='wp_participants_initial' label="Participants Initials" form={props.form} /> }

        <Form.Item>
          <label>
            <div className='form-label'>Do you consent to the terms described above?</div>
            {props.form.getFieldDecorator('consent_provided', {
              initialValue: props.consent_provided,
              rules: [{
                required: true,
                message: 'Do you consent to the terms described above?'
              }],
            })(
              <Select>
                <Option value="yes">Yes</Option>
                <Option value="">No</Option>
              </Select>
            )}
          </label>
        </Form.Item>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ConsentTypeWinnipeg/Step3aSubstudy.js